// extracted by mini-css-extract-plugin
export var deliveryRow = "_lo-a";
export var fixedHeight = "_lo-4";
export var freightLogo = "_lo-9";
export var fullWidth = "_lo-3";
export var priceColumn = "_lo-5";
export var radioSelected = "_lo-7";
export var radioUnselected = "_lo-6";
export var selectedOption = "_lo-2";
export var selectedOptionContainer = "_lo-1";
export var selection = "_lo-0";
export var tallSkeletonText = "_lo-8";